<template>
  <b-modal title="Informações da Imagem" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group
            label="Descrição:"
            label-for="descricao"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="descricao" v-model="editing.descricao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Local:" label-for="local" label-cols-sm="3" label-align-sm="right"
            ><b-form-input id="local" v-model="editing.local" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group
            label="Logomarca:"
            label-for="email"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-file
              type="file"
              class="text-left mt-1"
              v-model="arquivo"
              placeholder="Solte o arquivo da imagem .jpg"
              drop-placeholder="Solte o arquivo da imagem .jpg"
              accept=".jpg"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useImagemStore } from "@/stores/ImagemStore";
import Imagem from "@/models/Imagem";
import Notificacao from "@/models/Notificacao";
import Files from "@/http/files";

export default {
  name: "ModalDeEdicaoDeImagem",

  data() {
    return {
      show: false,
      editing: new Imagem(0, "", "", new Date()),
      files: new Files(this.$http),
      arquivo: null,
    };
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.imagemStore.ALTERAR_IMAGEM(this.editing).then(() => {
          this.store.NOTIFICAR(
            new Notificacao("Imagem salva no Banco de Imagem com sucesso!", "Excelente!", "success")
          );
          if (this.arquivo != null) {
            const filename = this.editing.id + ".jpg";
            let formData = new FormData();
            formData.append("name", this.arquivo.name);
            formData.append("file", this.arquivo);
            this.files.uploadImagem(filename, formData);
          }
        });
      } else {
        this.imagemStore
          .CADASTRAR_IMAGEM(this.editing)
          .then(() =>
            this.store.NOTIFICAR(
              new Notificacao(
                "Imagem salva no Banco de Imagem com sucesso!",
                "Excelente!",
                "success"
              )
            )
          );
      }
      this.show = !this.show;
    },

    call(imagem) {
      this.show = !this.show;
      this.editing = imagem;
    },
  },

  setup() {
    const store = useSgcqStore();
    const imagemStore = useImagemStore();

    return {
      store,
      imagemStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
